<template>
  <div class="out_wrap">
    <div class="between search">
      <div class="left flex1">
        <el-form ref="form" :model="queryControl" label-width="102px">
          <div class="form-box">
            <el-form-item label="管理员姓名:" class="formItem">
              <el-input v-model="queryControl.keyword" type="text" placeholder="请输入管理员姓名" clearable @keyup.native.enter="query" />
            </el-form-item>
            <el-form-item label="管理员手机号:" class="formItem">
              <el-input v-model="queryControl.account" type="text" placeholder="请输入管理员手机号" clearable @keyup.native.enter="query" />
            </el-form-item>
            <div>
              <el-button type="primary" @click="query(1)">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="right">
        <el-button type="primary" class="ml10" @click="$router.push('/account/role')"><i class="el-icon-user-solid" />角色管理</el-button>
        <el-button v-if="powerReg('6b9863e268c4e90dd18113621a1b7e4b')" type="primary" @click="create"><i class="el-icon-plus" />新增管理员</el-button>
      </div>
    </div>
    <zf-table
      :columns="columnEmployee"
      :data-source="tableData"
      :total="pageControl.total"
      :page-size="pageControl.pageSize"
      :page-num="pageControl.pageNumber"
      @change="handlePageChange"
    >
      <!-- 操作 -->
      <template
        slot="action"
        slot-scope="{ row }"
      >
        <a class="edit" @click="edit(row)">编辑</a>
        <el-divider v-if="row.status == 2" direction="vertical" />
        <a v-if="row.status == 2" class="edit" @click="setStatus(row, 1)">启用</a>
        <el-divider v-if="row.status == 1" direction="vertical" />
        <a v-if="row.status == 1" class="del" @click="setStatus(row, 2)">禁用</a>
        <el-divider direction="vertical" />
        <a class="del" @click="del(row)">删除</a>
      </template>
    </zf-table>
    <el-dialog :title="mode == 1 ? '新建管理员' : '编辑管理员'" :visible.sync="dialogFormVisible">
      <el-form ref="ruleForm" :model="groupOne" :rules="rules" class="demo-ruleForm" label-width="120px">
        <el-form-item label="管理员姓名：" prop="nickname">
          <el-input v-model="groupOne.nickname" placeholder="请输入管理员姓名" class="w100" clearable />
        </el-form-item>
        <el-form-item label="手机号：" prop="account">
          <el-input v-model="groupOne.account" placeholder="请输入管理员手机号" class="w100" maxlength="11" clearable :disabled="mode == 2" />
        </el-form-item>
        <el-form-item v-if="mode == 1" label="默认登录密码：">
          <el-input placeholder="默认登录密码" class="w100" disabled value="888888" />
        </el-form-item>
        <el-form-item label="权限角色：" prop="role_id">
          <el-select v-model="groupOne.role_id" placeholder="请选择权限角色" class="w100" clearable filterable>
            <el-option v-for="(item) in optionArr" :key="item.role_id" :label="item.role_name" :value="item.role_id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { roleList } from '@/api/accountInfo'
import ZfTable from '@/components/ZfTable/CoreTable'
import columnEmployee from './columns/employee'
export default {
  components: {
    ZfTable
  },
  data() {
    const validateAccount = (rule, value, callback) => {
      if (value !== '' && value !== undefined) {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入手机号'))
      }
    }
    return {
      columnEmployee,
      mode: 1, // 1-新建 2-编辑
      dialogFormVisible: false,
      groupOne: {},
      rules: {
        nickname: [{ required: true, message: '请输入管理员姓名', trigger: 'change' }],
        account: [{ required: true, validator: validateAccount, trigger: 'change' }],
        role_id: [{ required: true, message: '请选择权限角色', trigger: 'change' }]
      },
      optionArr: []
    }
  },
  computed: {
    ...mapGetters('accountInfo', ['tableData', 'queryControl', 'pageControl'])
  },
  created() {
    this.query(this.pageControl.pageNumber)
    roleList({ keyword: '', page: 1, pageSize: 999999 }).then(res => {
      if (res.code === 200) {
        this.optionArr = res.data.data
      }
    })
  },
  methods: {
    ...mapActions('accountInfo', ['operatorListFn', 'operatorStatusFn', 'editOperatorFn', 'addOperatorFn', 'adminDel']),
    async query(pg) {
      this.pageControl.pageNumber = pg
      await this.operatorListFn({ keyword: this.queryControl.keyword, account: this.queryControl.account, page: pg, pageSize: this.pageControl.pageSize })
    },
    resetForm() {
      this.queryControl.keyword = ''
      this.queryControl.account = ''
      this.query(1)
    },
    create() {
      this.mode = 1
      this.groupOne = {}
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate(['nickname', 'account', 'role_id'])
      })
    },
    edit(item) {
      this.mode = 2
      this.groupOne = { ...item, nickname: item.name }
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate(['nickname', 'account', 'role_id'])
      })
    },
    setStatus(item, type) {
      if (type === 2) {
        this.$confirm('禁用后该账号将无法登录（数据将保留），确认禁用此账号？', '禁用提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.operatorStatusFn({ account_id: item.id, status: type }).then(data => {
            if (data) {
              this.$message({ type: 'success', message: '禁用成功' })
              this.query(this.pageControl.pageNumber)
            }
          })
        })
      } else {
        this.operatorStatusFn({ account_id: item.id, status: type }).then(data => {
          if (data) {
            this.$message({ type: 'success', message: '启用成功' })
            this.query(this.pageControl.pageNumber)
          }
        })
      }
    },
    del(row) {
      this.$confirm('删除后该账号将无法登录，确认删除此账号？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.adminDel({ account_id: row.id }).then(data => {
          if (data.code === 200) {
            this.$message({ type: 'success', message: '删除成功' })
            this.query(this.pageControl.pageNumber)
          }
        })
      })
    },
    handlePageChange({ pageNum, pageSize, sorter: { prop, order }}) {
      this.pageControl.pageSize = pageSize
      this.query(pageNum)
    },
    submitForm(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          if (this.mode === 1) {
            const res = await this.addOperatorFn({
              account: this.groupOne.account,
              nickname: this.groupOne.nickname,
              role: this.groupOne.role_id
            })
            if (res.code === 200) {
              this.dialogFormVisible = false
              this.$message({ type: 'success', message: '新增成功' })
              this.query(this.pageControl.pageNumber)
            }
          } else {
            const res = await this.editOperatorFn({
              id: this.groupOne.id,
              account: this.groupOne.account,
              nickname: this.groupOne.nickname,
              role: this.groupOne.role_id
            })
            if (res.code === 200) {
              this.dialogFormVisible = false
              this.$message({ type: 'success', message: '编辑成功' })
              this.query(this.pageControl.pageNumber)
            }
          }
        }
      })
    },
    roleManage() {
      this.$router.push('/role')
    }
  }
}
</script>

<style lang="scss" scoped>
.formItem{
  width: calc( 40% - 24px);
}
</style>
